













































































































































import { Component, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue';
import ConversationDto from '@/models/Conversations/ConversationDto';
import MessageBody from '@/components/Messages/Display/MessageBody.vue';
import WorkerProfileMessagingSummary from '@/components/Workers/WorkerProfileMessagingSummary.vue';
import BookingRoleWorkerMessagingSummary from '@/components/BookingRoleWorkers/BookingRoleWorkerMessagingSummary.vue';
import ConversationStatus from '@/components/Conversations/Display/ConversationStatus.vue';
import ConversationListSearchCriteria from '@/components/Conversations/ConversationListSearchCriteria.vue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import ConversationTopicCountChip from '@/components/ConversationTopics/ConversationTopicCountChip.vue';
import ConversationTopicFirestoreDto from '@/models/ConversationTopics/ConversationTopicFirestoreDto';
import { AppModule } from '@/store/modules/app';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';
import ConversationParticipant from "@/components/Conversations/Display/ConversationParticipant.vue";
import AssignConversation from '@/components/Conversations/AssignConversation.vue';
import CreateConversationParticipant from '@/components/Conversations/CreateConversationParticipant.vue';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import ConversationStatusEdit from '@/components/Conversations/ConversationStatusEdit.vue';
import EntityTypeEnum from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import ConversationCreate from '@/components/Conversations/ConversationCreate.vue';

@Component({
	name: 'WorkerConversations',
  	components: { Alert, ConversationListSearchCriteria, ConversationCreate, MessageBody, BookingRoleWorkerMessagingSummary, ConversationParticipant, ConversationStatus, ConversationTopicCountChip, AssignConversation, ConversationStatusEdit, CreateConversationParticipant}
})
export default class extends GiganautVue {

  entityType = EntityTypeEnum;
  newMessage = '';
  myMessages = true;
  page = 1;
	perPage = 8;


  get conversations() {
    return WorkerDetailsModule.conversations;
  }

  get pagedConversations() {
		return this.conversations.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

  get bookingRoleWorkerSummary() {
    return WorkerDetailsModule.bookingRoleWorkerSummary;
  }

  get conversationTopics() {
    return WorkerDetailsModule.conversationTopics;
  }

  get showNewConversationBanner() {
    return WorkerDetailsModule.showNewConversationBanner;
  }

  getCountValue(count: number) {
    if (count > 9) {
        return "9+";
    }
    return count.toString();
  
  }

  get isParticipant() {
    return this.selectedConversation.participantFirebaseUserIds.includes(AppModule.currentUser.uid);
  }

  get selectedConversation() {
    return WorkerDetailsModule.workerConversationsVM.selectedConversation;
  }

  get selectedConversationId() {
		return WorkerDetailsModule.workerConversationsVM.selectedConversationId;
	}

	set selectedConversationId(id: string) {
	  WorkerDetailsModule.updateSelectedConversation(id);
	}

  @Watch('selectedConversationId', { immediate: true})
  async onConversationChanged(val: string, oldVal: string) {
    if (val != "") {
      await WorkerDetailsModule.updateSelectedConversation(val);
    }
  }

  get messages() {
      return WorkerDetailsModule.messages;
  }

  get loadingConversations() {
		return WorkerDetailsModule.loadingConversations;
   }

  get conversationParticipantsFiltered() {
    return WorkerDetailsModule.conversationParticipants.filter(item => item.entityType !== EntityTypeEnum.ChatBot);
  }

  get agencyUsers() {
    return WorkerDetailsModule.agencyUsers;
  }

  async joinConversation() {
    const request = new CreateConversationParticipantRequest();
    request.entityId = AppModule.userProfile.agencyUserId;
    request.entityType = this.EntityType.AgencyUser;
    await WorkerDetailsModule.createConversationParticipant(request);
  }

  getParticipant(message: MessageDto) {
      const participant = WorkerDetailsModule.conversationParticipants.find((findParticipant: ConversationParticipantDto) => findParticipant.id === message.firebaseUserId);
      return participant;
  }

  async beforeMount() {
    await WorkerDetailsModule.getConversations(1);
    await WorkerDetailsModule.getConversationTopics();
    await WorkerDetailsModule.getAgencyUsers();
  }

  async onPageChanged(input: number){
		WorkerDetailsModule.updateSelectedConversation(this.pagedConversations[0].id);
	}

  async sendMessage() {
    if (this.newMessage.trim() != '') {
      await WorkerDetailsModule.sendMessage(this.newMessage);
      this.newMessage = '';
    }
  }

  async getConversations() {
    await WorkerDetailsModule.getConversations(0);
  }

  getUserAvatarUrl(avatar: string, entityType: number, entityId: string) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/" + entityType.toString() + "/" + entityId + "/resized-100/" + avatar;
  }

  async clearMessage(){

  }
}
